import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LinksButtonModel } from './links-button.model';
import { LinksItemModel } from './links-data-item.model';
import { LinksButtonTypesEnum } from './links-button-types.enum';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, AbstractControl } from '@angular/forms';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
    standalone: false
})
export class LinksComponent implements OnInit {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() public dataSource: any;
    @Input() public buttons: LinksButtonModel[];
    @Input() public maxLinkItems: number;
    @Input() public linkFormatErrorMessage: string;
    @Input() public isDisabled: boolean = false;
    @Output() public controlDelete: EventEmitter<any> = new EventEmitter();
    @Input() public isLinkDirty: boolean = false;
    @Output() public isLinkDirtyChange: EventEmitter<boolean> = new EventEmitter();

    public addtype = LinksButtonTypesEnum.Add;
    public userForm: UntypedFormGroup;
    public textIndex: number = -1;

    constructor(private fb: UntypedFormBuilder) {

    }

    ngOnInit() {
        this.userForm = this.fb.group({
            'linktextUrl': new UntypedFormControl('')
        });
    }

    get linktextUrl(): AbstractControl {
        return this.userForm.get('linktextUrl');
    }

    add(itemIndex: number) {
        const linksNewItem = new LinksItemModel();
        this.dataSource.addLink(linksNewItem);
        this.textIndex = itemIndex + 1;
    }

    edit(itemIndex: number) {
        this.textIndex = itemIndex;
    }

    delete(item: LinksItemModel) {
        if (item.id !== 0) {
            this.isLinkDirtyChange.emit(true);
        }
        this.dataSource.deleteLink(item);
        this.dataSource.all().subscribe(value => {
            if (!value || value.length === 0) {
                this.onDelete();
                this.textIndex = 0;
            }
        });
    }

    public onLinkTextInput(): void {
        this.isLinkDirtyChange.emit(true);
    }

    onLinkInputBlur(event: KeyboardEvent, item: LinksItemModel, index: number, linkValue: string): void {
        if (this.userForm.invalid) {
            return;
        }

        if (this.userForm.dirty) {
            this.isLinkDirtyChange.emit(true);
        }

        item.webAddress = linkValue;
        this.dataSource.updateLink(item, index);
        event.preventDefault();
        this.textIndex = -1;
    }

    onEdit(): void {
        const linksNewItem = new LinksItemModel();
        this.dataSource.addLink(linksNewItem);
        this.textIndex = 0;
    }

    onDelete(): void {
        this.controlDelete.emit();
    }

    onItemDelete(item: LinksItemModel): void {
        this.dataSource.deleteLink(item);
        this.textIndex = -1;
    }

    public openLinkBlock(itemIndex: number): void {
        if (this.isDisabled) {
            return;
        }
        this.textIndex = itemIndex;
    }
}
